var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "lazy",
          rawName: "v-lazy:background-image",
          value: _vm.video_thumbnail,
          expression: "video_thumbnail",
          arg: "background-image"
        }
      ],
      staticClass: "video-component__player-wrapper",
      attrs: { role: "img", "aria-label": `Video: ${_vm.video_title}` }
    },
    [
      _c("div", { staticClass: "video-component__thumbnail" }, [
        _c(
          "button",
          {
            staticClass: "video-component__play-btn",
            attrs: { "aria-label": "play button" },
            on: { click: _vm.openVideo }
          },
          [_vm._t("play-button")],
          2
        )
      ]),
      _vm._v(" "),
      _vm.video_url
        ? _c(
            "Modal",
            { ref: "video", staticClass: "video-modal" },
            [
              _c("template", { slot: "content" }, [
                _vm.youtubeVideo
                  ? _c("iframe", {
                      attrs: {
                        id: "video-component__player-embed",
                        src: _vm.youtubeEmbedLink,
                        title: "Video Player",
                        frameborder: "0",
                        allow:
                          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                        allowfullscreen: ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.vimeoVideo
                  ? _c("iframe", {
                      attrs: {
                        id: "video-component__player-embed",
                        src: _vm.vimeoEmbedLink,
                        frameborder: "0"
                      }
                    })
                  : _vm._e()
              ])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }